import type { CSSProperties, ReactNode } from 'react';

/**
 * A card is for things the app is TELLING him (Now, receipts, stack cards,
 * approvals) — never for browsing (that is a Group). One primary action.
 */
export default function Card({
  eyebrow,
  title,
  accent,
  tone = 'default',
  actions,
  className,
  label,
  children,
}: {
  eyebrow?: ReactNode;
  title?: ReactNode;
  /** A 4px leading bar (sphere or status colour). */
  accent?: string;
  tone?: 'default' | 'now' | 'quiet';
  actions?: ReactNode;
  className?: string;
  label?: string;
  children?: ReactNode;
}): JSX.Element {
  return (
    <section
      className={`ui-card ui-card--${tone}${accent ? ' ui-card--accent' : ''}${className ? ` ${className}` : ''}`}
      style={accent ? ({ '--card-accent': accent } as CSSProperties) : undefined}
      aria-label={label}
    >
      {eyebrow && <div className="ui-card__eyebrow">{eyebrow}</div>}
      {title && <h2 className="ui-card__title">{title}</h2>}
      {children}
      {actions && <div className="ui-card__actions">{actions}</div>}
    </section>
  );
}
